import { forwardRef } from "react";
import { DropDown } from "@etframework/ui.components";
import { useClients } from "../../data/queries/clientQueries";
import { Trans, useTranslation } from "react-i18next";

export const ClientDropDown = forwardRef(
  ({ onChange, initialValue, id }, ref) => {
    const { t, i18n } = useTranslation(["CreateTaskModal"]);

    const { data: clientData } = useClients();
    const fields = {
      text: "FullName",
      value: "Id",
    };

    return (
      <DropDown
        ref={ref}
        value={clientData?.find?.((x) => x.Id === initialValue)}
        name="ClientId"
        dataSource={clientData}
        fields={fields}
        htmlFor={id}
        id={id}
        label={
          <Trans components={{ b: <span className="et-red" /> }}>
            {t("ClientLabel")}
          </Trans>
        }
        errorMessage={t("ErrorMsg")}
        locale={i18n?.language}
        change={onChange}
        allowObjectBinding
        sortOrder="Ascending"
        allowFiltering
      />
    );
  }
);
